export const fieldStructure = Object.freeze({
  item_id: null,
  name: "",
  type: "",
  logic: {},
  errors: {},
  hasErrors: false,
  options: {
    required: false,
    app: false,
    export: false,
    ocr: false,
    fieldTypeCfg: { data: {} },
  },
  show_if: [], // [{ field: '<item_id>', op: '==', value: 'value' }]
  show_logic: "all",
  refill_if: [], // [{ field: '<item_id>', op: '==', value: 'x', same_value: true|false, new_value: '', copy_from_field: '', overwrite: true|false }]
  refill_logic: "all",
});

export const fieldTypes = [
  {
    name: "maintenance.site",
    type: "site",
    data_type: "text",
    icon: "site.svg",
    config: [],
  },
  {
    name: "maintenance.document_number",
    type: "document_number",
    data_type: "text",
    icon: "document-number.svg",
    config: [],
  },
  {
    name: "maintenance.facility",
    type: "facility",
    data_type: "hidden",
    icon: "",
    config: [],
  },
  {
    name: "maintenance.select",
    type: "select",
    data_type: "select",
    icon: "select.svg",
    config: [{}],
  },
  {
    name: "maintenance.multiple_select",
    type: "multiple_select",
    data_type: "select",
    icon: "select.svg",
    config: [{}],
  },
  {
    name: "maintenance.asset",
    type: "asset",
    data_type: "file",
    icon: "assets.svg",
    config: [],
  },
  {
    name: "maintenance.text_answer",
    type: "text_answer",
    data_type: "textarea",
    icon: "text-answer.svg",
    config: [],
  },
  {
    name: "maintenance.checkbox",
    type: "checkbox",
    data_type: "checkbox",
    icon: "checkbox.svg",
    config: [{}],
  },
  {
    name: "maintenance.date_time",
    type: "date_time",
    data_type: "datetime-local",
    icon: "date-time.svg",
    config: [{}],
  },
  {
    name: "maintenance.media",
    type: "media",
    data_type: "file",
    icon: "media.svg",
    config: [
      {
        id: "min",
        name: "maintenance.min",
        type: "number",
      },
      {
        id: "max",
        name: "maintenance.max",
        type: "number",
      },
      {
        id: "canCrop",
        name: "maintenance.can_crop",
        type: "boolean",
      },
    ],
  },
  {
    name: "maintenance.slider",
    type: "slider",
    data_type: "range",
    icon: "slider.svg",
    config: [
      {
        id: "min",
        name: "maintenance.min",
        type: "number",
      },
      {
        id: "max",
        name: "maintenance.max",
        type: "number",
      },
      {
        id: "increment",
        name: "maintenance.increment",
        type: "number",
      },
    ],
  },
  {
    name: "maintenance.number",
    type: "number",
    data_type: "number",
    icon: "number.svg",
    config: [
      {
        id: "min",
        name: "maintenance.min",
        type: "number",
      },
      {
        id: "max",
        name: "maintenance.max",
        type: "number",
      },
    ],
  },
  {
    name: "maintenance.annotation",
    type: "annotation",
    data_type: "text",
    icon: "annotation.svg",
    config: [],
  },
  {
    name: "maintenance.signature",
    type: "signature",
    data_type: "image",
    icon: "signature.svg",
    config: [],
  },
  {
    name: "maintenance.location",
    type: "location",
    data_type: "map",
    icon: "location.svg",
    config: [],
  },
  {
    name: "maintenance.instruction",
    type: "instruction",
    data_type: "text",
    icon: "instructions.svg",
    config: [],
  },
];
